import DefaultRenderer from './default';
import { TimelineMax, Expo, Power4, TweenMax } from 'gsap';
import form from '../../components/form';

class job extends DefaultRenderer {
	onEnter() {
		super.onEnter();

		// Get Scroll Instance
		let mainScroll = this.mainController.getScroll();

		// Enable Dropbox feature
		let Dropbox = window.Dropbox,
			dropboxButton = document.getElementsByClassName('dropbox-file'),
			options = {
				// Required. Called when a user selects an item in the Chooser.
				success: function(files) {
					alert('Heres the file link: ' + files[0].link);
				},

				// Optional. Called when the user closes the dialog without selecting a file
				// and does not include any parameters.
				cancel: function() {},

				// Optional. "preview" (default) is a preview link to the document for sharing,
				// "direct" is an expiring link to download the contents of the file. For more
				// information about link types, see Link types below.
				linkType: 'direct', // or "direct"

				// Optional. A value of false (default) limits selection to a single file, while
				// true enables multiple file selection.
				multiselect: false, // or true

				// Optional. This is a list of file extensions. If specified, the user will
				// only be able to select files with these extensions. You may also specify
				// file types, such as "video" or "images" in the list. For more information,
				// see File types below. By default, all extensions are allowed.

				// Optional. A value of false (default) limits selection to files,
				// while true allows the user to select both folders and files.
				// You cannot specify `linkType: "direct"` when using `folderselect: true`.
				folderselect: false, // or true

				// Optional. A limit on the size of each file that may be selected, in bytes.
				// If specified, the user will only be able to select files with size
				// less than or equal to this limit.
				// For the purposes of this option, folders have size zero.
			};

		Dropbox.appKey = '2tedlg64vjg04za';

		for (let index = 0; index < dropboxButton.length; index++) {
			dropboxButton[index].addEventListener('click', e => {
				e.preventDefault();
				Dropbox.choose(options);
			});
		}

		// Apply now toggle animation
		let goToFormButton = document.getElementById('go-to-form'),
			applyNowButton = document.getElementById('apply-button'),
			jobForm = document.getElementById('job-form'),
			toggleTl = new TimelineMax({
				onUpdate: () => {
					mainScroll.update();
				},
				paused: true,
			}),
			formStaggerArray = [
				jobForm.getElementsByTagName('h4')[0],
				document.getElementById('applyLinkedin'),
				jobForm.getElementsByTagName('form')[0],
			];

		// Toggle Form
		function toggleForm() {
			jobForm.classList.add('open');
			TweenMax.to(applyNowButton, 0.01, { autoAlpha: 0 });
			TweenMax.set(jobForm, { height: 'auto' });

			TweenMax.from(jobForm, 0.5, { height: 0, ease: Expo.easeOut });
			TweenMax.to(jobForm.querySelector('.grid-container'), 0.5, {
				autoAlpha: 1,
				ease: Expo.easeOut,
			});

			toggleTl.staggerTo(formStaggerArray, 0.3, { y: 0, autoAlpha: 1, ease: Power4.easeInOut }, 0.05);

			toggleTl.play();

			mainScroll.update();
		}

		applyNowButton.addEventListener('click', function() {
			toggleForm();
		});

		goToFormButton.addEventListener('click', function() {
			toggleForm();
			mainScroll.scrollTo(jobForm);
		});

		// Submit Form
		form(mainScroll);
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default job;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/job.js